import { classifyUser } from '../user';
import {
  activationKey, authenticationCheck, getIdPortenToken, idPorten
} from './authentication';
import { info, warn } from '../notify';
import { fillProfileIn } from '../user';
import { moveTo } from '../wizard';

const ws = '/klimagasskalkulator_ws';

const removeParameterFromUrl = (p) => {
  const cleared = new URLSearchParams(window.location.search);
  cleared.delete(p);
  // Remove query parameters from URL without refreshing the page
  // window.location.search = ''; // not desirable, it also refreshes
  window.history.replaceState({}, document.title, `?${cleared.toString()}`);
};

export const getUserInfo = () => new Promise((resolve, reject) => {
  console.log('Get user information');
  getIdPortenToken().then(token => {
    const request = new Request(`${ws}/user`, {
      method: 'GET',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(
      request,
      response => {
        console.log(response);
        const name = (response.name || response.email);
        info(`Logget inn som «${name}»`);
        if (response.userActivated) {
          sessionStorage.removeItem(activationKey);
          removeParameterFromUrl(activationKey);
        }
        fillProfileIn(response);
        resolve(response);
      },
      () => reject(console.log('onError'))
      // () => console.log('onComplete')
    );
  }).catch(err => reject(console.log('catch', err)));
});

const succeed = (msg) => {
  info(msg);
  sessionStorage.removeItem(activationKey);
  removeParameterFromUrl(activationKey);
  moveTo('home');
  authenticationCheck(); // to load user information we did not get before
};
